// extracted by mini-css-extract-plugin
export default {"optionsContainer":"PartnerProducts_optionsContainer__jtuw6"};